//make sure that the storage component is loaded when the
//app is bootstrapped. This will cause the localStorage I/O overhead to be front-
//loaded
angular.module('picmonicng').run(['LocalStorageService', function (LocalStorageService) {}]);

//This is the keyvalue used for storage management
angular.module('picmonicng').value('storageKey', 'picmonicng');

//Provide a storage API that uses an in-memory data cache that is persisted
//to the localStorage at the limits of the application life-cycle.
angular.module('picmonicng').factory('LocalStorageService', [
  '$exceptionHandler',
  '$window',
  'storageKey',
  function ($exceptionHandler, $window, storageKey) {
    // Try to load the initial payload from localStorage.
    try {
      items = loadData();
    } catch (e) {
      items = {};
    }

    //collection of callbacks that want to hook into the
    //unload event of the in-memory cache. This will give the calling
    //context a chance to update their relevant storage items before
    //the data is persisted to localStorage.
    var persistHooks = [];
    //determine if the cache should be persisted to localStorage when the
    //application is unloaded.
    var persistEnabled = true;
    //During the application lifetime, we're going to be using in-memory
    //data access. when the application unloads, we want to try
    //to persist the in-memory cache to the localStorage.
    $window.addEventListener('beforeunload', persistData);

    //Return the public API.
    return {
      // ---
      // PUBLIC METHODS.
      // ---
      // clear current item cache.
      clear: function () {
        items = {};
      },
      // disable the persisting of the cache to localStorage on unload.
      disablePersist: function () {
        persistEnabled = false;
      },
      // enable the persisting of the cache to localStorage on unload.
      enablePersist: function () {
        persistEnabled = true;
      },
      //remove given key from the cache and return the value that was
      // cached at that key; returns null if the key didn't exist.
      extractItem: function (key) {
        var value = this.getItem(key);
        this.removeItem(key);
        return value;
      },
      //return the item at the given key; returns null if not available.
      getItem: function (key) {
        key = normalizeKey(key);
        //using .copy() so that the internal cache can't be
        //mutated through reference to that object.
        return key in items ? angular.copy(items[key]) : null;
      },
      // add fucnction to persist hooks that will be invoked prior
      // to unload-based persistence.
      onBeforePersist: function (operator) {
        persistHooks.push(operator);
      },
      //remove the given key from the cache.
      removeItem: function (key) {
        key = normalizeKey(key);
        delete items[key];
      },
      //store the item at the given key.
      setItem: function (key, value) {
        key = normalizeKey(key);
        items[key] = angular.copy(value);
      },
    };

    // ---
    // PRIVATE METHODS.
    // ---
    // load the cache from the localStorage interface. Once the
    // data is loaded, it is deleted from localStorage.
    function loadData() {
      // There's a chance that the localStorage isn't available
      try {
        if (storageKey in $window.localStorage) {
          var data = $window.localStorage.getItem(storageKey);
          $window.localStorage.removeItem(storageKey);
          return angular.extend({}, angular.fromJson(data));
        }
      } catch (localStorageError) {
        $exceptionHandler(localStorageError);
      }
      return {};
    }

    //prefix the given cache key so that we never collide with any
    //native object keys when looking up.
    function normalizeKey(key) {
      return 'storage_' + key;
    }
    //attempt to persist the cache to the localStorage.
    function persistData(e) {
      if (e && e.type === 'beforeunload' && window.skip_local_storage_persist_on_beforeunload === 1) {
        delete window.skip_local_storage_persist;
        return;
      }

      //Before we persist the data, invoke all of the before-persist hook
      //operators so that consuming services have one last chance to
      //synchronize their local data with the storage data.
      for (var i = 0, length = persistHooks.length; i < length; i++) {
        try {
          persistHooks[i]();
        } catch (persistHookError) {
          $exceptionHandler(persistHookError);
        }
      }
      // If persistence is disabled, skip the localStorage access.
      if (!persistEnabled) {
        return;
      }
      // Having run all persistHooks we try and setItem to localStorage, if available
      try {
        $window.localStorage.setItem(storageKey, angular.toJson(items));
      } catch (localStorageError) {
        $exceptionHandler(localStorageError);
      }
    }
  },
]);
